import React, { useCallback, useState } from "react";
import { Button } from "@mui/material";

import { CONTENTS_TYPE } from '../../const/general'
import { Image, Video, } from '../../style/image'
import DropBox from '../../items/file_drop_box';

import ZipImg from '../../_img/img_thumb_zip.png'

export default function UploadThumb(props) {
  const [thumbnailUrl, setThumbnailUrl] = useState(null);

  const onDrop = useCallback((acceptedFiles) => {
    // 新たにサムネイルファイルがドロップされたら
    // ファイルを検証してOKならアップロードファイルに追加する
    acceptedFiles.map((file) => { validateFile(file) })
  }, []);
  const validateFile = async (file) => {
    const validTypes =
      [
        'image/png',
        'image/jpeg',
        'image/gif'
      ];
    // ファイルタイプが動画でも画像でもない場合はエラー
    console.log(file.type)


    if (validTypes.indexOf(file.type) === -1) {
      alert('申し訳ございません。指定されたファイルはアップロードできません。\n 画像ファイルをご指定ください。')
      return null;
    } else {
      if (file && props.onThumbnailReady) {
        props.onThumbnailReady(file);
      }
      // setThumbnailFile(file);
      setThumbnailUrl(URL.createObjectURL(file))
    }
    return true;
  }
  // リセット処理
  const handleReset = useCallback(() => {
    props.onThumbnailReady(null);
    // setThumbnailFile(null);
    setThumbnailUrl(null);
  }, []);
  return (
    <>
      {props.contentType === CONTENTS_TYPE.MOVIE && (
        <Video
          controls
          src={props.url}
          resizeMode="contain"
          poster={props.thumbnailUrl}
        />
      )}

      {props.contentType === CONTENTS_TYPE.IMAGE && (
        <Image
          controls
          src={props.url}
          resizeMode="contain"
        />
      )}

      {props.contentType === CONTENTS_TYPE.ZIP && (
        <Image
          controls
          src={ZipImg}
          resizeMode="contain"
        />
      )}

      {props.contentType === CONTENTS_TYPE.LAS && (
        thumbnailUrl ? (
          <>
            <Image
              controls
              src={thumbnailUrl}
              resizeMode="contain"
            />
            <Button
              variant="contained"
              size="small"
              sx={{
                mt: 1,
                color: '#333',
                boxShadow: 'none',
                backgroundColor: 'rgb(0 0 0 / 10%)',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.12)',
                },
              }}
              onClick={handleReset}
            >
              サムネイルをリセット
            </Button>
          </>
        ) : (
          <DropBox
            onDrop={onDrop}
            isThumbnail={true}
            acceptTypes={
              [
                ".png",
                ".gif",
                ".jpg",
                ".jpeg"
              ]
            }
          />
        )
      )}
    </>
  );
}
